import * as yup from "yup";
import { useRouterQueryParams } from "@/react/hooks/useRouterQueryParamsV2";
import { ALL_STATUS } from "../constants";
import type { UsePostsApiProps } from "./usePostsApi";
import { usePostsApi } from "./usePostsApi";

export const usePosts = (filters = {}) => {
  const { page: pageNumber, ...filterParams } = useRouterQueryParams(
    yup.object(),
  );

  const page = Number(pageNumber) || 1;
  const filter = { status: ALL_STATUS, ...filterParams, ...filters };

  const params: UsePostsApiProps = { page, filter };
  if (filter.status === "scheduled") {
    params.sort = "scheduled_at";
  }

  const { posts, postsCount, isLoadingPosts } = usePostsApi(params);

  return {
    posts,
    postsCount,
    isLoadingPosts,
    filter,
    page,
  };
};
